<i18n lang="yaml">
  pt:
    support: "Suporte"
    support-title: "Acesse nosso suporte"
    documentation: "Documentação"
    documentation-title: "Acessar documentação"
</i18n>

<template>
  <figure
    data-grid
    class="grid--va-center grid--center full-rounded m-0 cursor-pointer p-relative has-tooltip"
  >
    <QuestionMarkIcon />

    <TooltipApp>
      <ul>
        <li>
          <a
            href="https://docs.increazy.com/"
            :title="$t('documentation-title')"
          >
            {{ $t('documentation') }}
          </a>
        </li>

        <li>
          <a
            :title="$t('support-title')"
            href="https://tawk.to/chat/62712ab0b0d10b6f3e706d0d/1g250tgm3"
          >
            {{ $t('support') }}
          </a>
        </li>
      </ul>
    </TooltipApp>
  </figure>
</template>

<script>
import { defineComponent } from 'vue'

import QuestionMarkIcon from '../icons/QuestionMarkIcon'
import TooltipApp from '../grid/header/apps/components/TooltipApp'

export default defineComponent({
  name: 'HelpDropDown',

  components: {
    TooltipApp,
    QuestionMarkIcon
  }
})
</script>

<style lang="scss" scoped>
  figure {
    .is-dark-theme & {
      background-color: rgb(var(--black1));
    }
  }

  ul {
    width: 175px;

    li {
      & + li {
        margin-block: 5px 0;
      }

      &:hover a {
        color: rgba(var(--gray1), .8);
      }

      a {
        transition: .2s ease-in-out;

        color: rgb(var(--gray1));
        font: 700 1.5rem "Nunito", sans-serif;
      }
    }
  }

  .is-dark-theme ul li a {
    color: rgb(var(--gray6));
  }
</style>
